import { createSlice } from "@reduxjs/toolkit";
import {
    getActiveOrgsForResellerThunk,
    getBotMISReports,
    getCampaignMISReportsByFilter,
    getCampaignsForCampaignMIS,
    updateBotMISReports,
    getMISReportsThunk,
    updateCampaignMISReports,
    updateBillingMISReports,
} from "./misReportsThunk";

export const misReportsSlice = createSlice({
    name: "misReportsSlice",
    initialState: {
        campaignMISReports: [],
        campaignDataList: [],
        campaignDataCount: 0,
        campaignMISReportsTotalCount: 0,
        totalCampaignMISCounts: {},
        totalBillingMISCounts: {},
        updateCampaignMISReports: false,
        botMISReports: [],
        botMISReportsCount: 0,
        updateBotMISReportsMessage: false,
        billingMISReports: [],
        billingMISReportsCount: 0,
        updateBillingMISReports: false,
        // ------- Active Orgs -------
        activeOrgList: [],
        activeOrgCount: 0,

        // ------- Loading States -------
        getCampaignMISReporertsLoading: false,
        activeOrgLoading: false,
        campaignDataLoading: false,
        updateCampaignMISReportsLoading: false,
        getBotMISReportsLoading: false,
        updateBotMISReportsLoading: false,
        getBillingMISReportsLoading: false,
        updateBillingMISReportsLoading: false,

        // ------- Error Messages -------
        getCampaignMISReportsError: "",
        getAllActiveOrgErrorMessege: "",
        getCampaignForCampaignMISError: "",
        updateCampaignMISReportsError: "",
        getBotMISReportsError: "",
        updateBotMISReportsError: "",
        getBillingMISReportsError: "",
        updateBillingMISReportsError: "",
    },
    reducers: {
        clearErrorMessagesForCampaignMIS: (state, action) => {
            state[`${action.payload.fieldName}`] = "";
        },
        clearErrorMessagesForBotMIS: (state, action) => {
            state[`${action.payload.fieldName}`] = "";
        },

        setTotalCampaignMISCounts: (state, action) => {
            const status = action.payload.status;
            const count = state.totalCampaignMISCounts[status] || 0;
            const tempCount = action.payload.count;
            state.totalCampaignMISCounts = { ...state.totalCampaignMISCounts, [status]: count + tempCount };
        },
        resetTotalCampaignMISCounts: (state, action) => {
            state.totalCampaignMISCounts = {};
        },

        setTotalBillingMISCounts: (state, action) => {
            const status = action.payload.status;
            const count = state.totalBillingMISCounts[status] || 0;
            const tempCount = action.payload.count;
            state.totalBillingMISCounts = { ...state.totalBillingMISCounts, [status]: count + tempCount };
        },
        resetTotalBillingMISCounts: (state, action) => {
            state.totalBillingMISCounts = {};
        },
        resetUpdateCampaignReportStates: (state, action) => {
            state.updateCampaignMISReports = false;
            state.updateCampaignMISReportsLoading = false;
            state.updateCampaignMISReportsError = "";
        },
        resetUpdateBotReportStates: (state, action) => {
            state.updateBotMISReportsError = "";
            state.updateBotMISReportsLoading = false;
            state.updateBotMISReportsMessage = false;
        },
    },
    extraReducers: builder => {
        //--------------------------------- Campaign MIS ---------------------------------------------------------

        // ================================= Get ORG List ==================================
        builder.addCase(getActiveOrgsForResellerThunk.pending, (state, action) => {
            state.activeOrgLoading = true;
        });
        builder.addCase(getActiveOrgsForResellerThunk.fulfilled, (state, action) => {
            state.activeOrgList = action.payload.data;
            state.activeOrgCount = action.payload.totalCount;
            state.activeOrgLoading = false;
        });
        builder.addCase(getActiveOrgsForResellerThunk.rejected, (state, action) => {
            state.listAllBrandsErrorMessage = action.error.message;
            state.activeOrgLoading = false;
        });

        // ================================== Get Campaigns ===========================
        builder.addCase(getCampaignsForCampaignMIS.pending, (state, action) => {
            state.campaignDataLoading = true;
        });
        builder.addCase(getCampaignsForCampaignMIS.fulfilled, (state, action) => {
            state.campaignDataList = action.payload.allCampaigns;
            state.campaignDataCount = action.payload.totalCount;
            state.campaignDataLoading = false;
        });
        builder.addCase(getCampaignsForCampaignMIS.rejected, (state, action) => {
            state.getCampaignForCampaignMISError = action.error.message;
            state.campaignDataLoading = false;
        });
        // ================================== Campaign MIS ===========================
        builder.addCase(getCampaignMISReportsByFilter.pending, (state, action) => {
            state.getCampaignMISReporertsLoading = true;
        });
        builder.addCase(getCampaignMISReportsByFilter.fulfilled, (state, action) => {
            state.getCampaignMISReporertsLoading = false;
            state.campaignMISReports = action.payload.data;
            state.campaignMISReportsTotalCount = action.payload.totalCount;
        });
        builder.addCase(getCampaignMISReportsByFilter.rejected, (state, action) => {
            state.getCampaignMISReporertsLoading = false;
            state.getCampaignMISReportsError = action.error.message;
        });
        // ================================== Campaign MIS ===========================
        builder.addCase(updateCampaignMISReports.pending, (state, action) => {
            state.updateCampaignMISReportsLoading = true;
        });
        builder.addCase(updateCampaignMISReports.fulfilled, (state, action) => {
            state.updateCampaignMISReportsLoading = false;
            state.updateCampaignMISReports = true;
        });
        builder.addCase(updateCampaignMISReports.rejected, (state, action) => {
            state.updateCampaignMISReportsLoading = false;
            state.updateCampaignMISReportsError = action.error.message;
        });
        // ================================== Billing MIS ===========================
        builder.addCase(updateBillingMISReports.pending, (state, action) => {
            state.updateBillingMISReportsLoading = true;
        });
        builder.addCase(updateBillingMISReports.fulfilled, (state, action) => {
            state.updateBillingMISReportsLoading = false;
            state.updateBillingMISReports = true;
        });
        builder.addCase(updateBillingMISReports.rejected, (state, action) => {
            state.updateBillingMISReportsLoading = false;
            state.updateBillingMISReportsError = action.error.message;
        });
        // ================================== Bot MIS ===========================
        builder.addCase(getBotMISReports.pending, (state, action) => {
            state.getBotMISReportsLoading = true;
        });
        builder.addCase(getBotMISReports.fulfilled, (state, action) => {
            state.getBotMISReportsLoading = false;
            state.botMISReports = action.payload.reports;
            state.botMISReportsCount = action.payload.totalCount;
        });
        builder.addCase(getBotMISReports.rejected, (state, action) => {
            state.getBotMISReportsLoading = false;
            state.getBotMISReportsError = action.error.message;
        });

        // ================================== Billing MIS ===========================
        builder.addCase(getMISReportsThunk.pending, (state, action) => {
            state.getBillingMISReportsLoading = true;
        });
        builder.addCase(getMISReportsThunk.fulfilled, (state, action) => {
            state.getBillingMISReportsLoading = false;
            state.billingMISReports = action.payload.misData;
            state.billingMISReportsCount = action.payload.totalCount;
        });
        builder.addCase(getMISReportsThunk.rejected, (state, action) => {
            state.getBillingMISReportsLoading = false;
            state.getBillingMISReportsError = action.error.message;
        });

        // ================================== Bot MIS Update ===========================

        builder.addCase(updateBotMISReports.pending, (state, action) => {
            state.updateBotMISReportsLoading = true;
        });
        builder.addCase(updateBotMISReports.fulfilled, (state, action) => {
            state.updateBotMISReportsLoading = false;
            state.updateBotMISReportsMessage = true;
        });
        builder.addCase(updateBotMISReports.rejected, (state, action) => {
            state.updateBotMISReportsLoading = false;
            state.updateBotMISReportsError = action.error.message;
        });
    },
});

export const {
    clearErrorMessagesForCampaignMIS,
    clearErrorMessagesForBotMIS,
    getCampaignMISReportsError,
    getAllActiveOrgErrorMessege,
    setTotalCampaignMISCounts,
    resetTotalCampaignMISCounts,
    resetUpdateCampaignReportStates,
    resetUpdateBotReportStates,
} = misReportsSlice.actions;
export default misReportsSlice;
